import React from 'react'
import { Paper, Grid, Avatar, Typography, IconButton } from '@material-ui/core'
import CloseIcon from '@material-ui/icons/Close'
import { withStyles } from '@material-ui/core/styles'
import { useTranslation } from 'react-i18next'

import defaultImage from '../../../assets/images/Default.jpg'

const styles = theme => ({
  paper: {
    width: 200,
    margin: theme.spacing.unit * 2,
    padding: theme.spacing.unit,
    display: 'flex',
    justifyContent: 'space-between'
  },
  container: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between'
  },
  avatar: {
    margin: '0 auto',
    width: 100,
    height: 100
  },
  name: {
    padding: theme.spacing.unit
  },
  deleteButton: {
    position: 'relative',
    marginLeft: '75%'
  }
})

const SubscriberCard = ({ classes, image, name, interests, description, removeSubscriber }) => {
  const { t } = useTranslation()
  const avatar = image ? 'data:image/png;base64,' + image : defaultImage

  const handleCloseButton = () => {
    const isRemove = window.confirm(t('Cabinet:remove subscriber confirm'))
    if (isRemove) removeSubscriber()
  }

  return (
    <Paper className={classes.paper}>
      <Grid item className={classes.container}>
        <div>
          {/* delete button */}
          <IconButton
            className={classes.deleteButton}
            aria-label='delete'
            size='small'
            onClick={handleCloseButton}
          >
            <CloseIcon fontSize='inherit' />
          </IconButton>

          {/* subscriber's avatar */}
          <Avatar src={avatar} className={classes.avatar} />

          {/*  subscriber's name */}
          <Typography variant='h5' className={classes.name}>
            {name}
          </Typography>

        </div>

        {/*  subscriber's description */}
        {
          (description) ? (
            <Typography variant='body2' color='textSecondary' component='p'>
              {description}
            </Typography>

          ) : null
        }

        {/* subscriber's interests */}
        <Typography variant='subtitle1' className={classes.notification}>
          {interests.toString()}
        </Typography>
      </Grid>
    </Paper>
  )
}

export default withStyles(styles)(SubscriberCard)
